export default __webpack_public_path__ + "static/media/emerald.4aa2eba9.png";